import React from "react";
import { Link } from "react-router-dom";

function Header() {

    return (
        // <header style={headerStyle}>
        //     <h1>My TodoList</h1>
        //     <Link to="/ReactApp" style={LinkStyle}>Home</Link>{" "} 
        //     | <Link to="/about" style={LinkStyle}>About</Link>
        // </header>

            <header style={headerStyle}>
            <h1>My Todolist</h1>
            <Link to="/ReactApp" style={LinkStyle}>Home</Link> {" "} | {" "} <Link to="/about" style={LinkStyle}> About</Link>
            </header>
    );
}

const headerStyle = {
    background: '#222',
    color: '#fff',
    textAlign: 'center',
    padding: '6px'
};

const LinkStyle = {
    color: "#fff",
    textDecoration: "none"
  };

export default Header;